import { IFieldProps } from "@/models";
import { InputNumber, InputNumberProps } from "primereact";
import React from "react";
import { useTranslation } from "react-i18next";

interface InputNumberFieldProps extends InputNumberProps, IFieldProps {}

const InputNumberField: React.FC<InputNumberFieldProps> = ({
 getFormErrorMessage,
 labelName,
 labelText,
 ...rest
}) => {
 const { t } = useTranslation();
 return (
  <div className="field">
   <label htmlFor={labelName}>{t(labelText)}</label>
   <InputNumber {...rest} />
   {getFormErrorMessage != null && getFormErrorMessage()}
  </div>
 );
};

export default InputNumberField;
